import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

export default {
  getPayments(urlSearchParams) {
    return http.get(endpoints.get('filterPayments'), {
      params: urlSearchParams,
      withCredentials: true
    })
  },
  getPayment(payload) {
    return http.get(endpoints.get('payment', { paymentId: payload }))
  },
  cancelPayment(payload) {
    return http.post(endpoints.get('cancelPayment', { paymentId: payload }))
  },
  editPayment(payload) {
    return http.post(endpoints.get('paymentUpdate', { ...payload }), payload.data)
  },
  editDonorData(payload, paymentId) {
    return http.post(endpoints.get('paymentPersonalData', { paymentId }), payload)
  },
  createTraditional(paymentId) {
    return http.post(endpoints.get('paymentCreateTraditional', { paymentId }))
  },
  updatePaymentNote(payload, paymentId) {
    return http.post(endpoints.get('updatePaymentNote', { paymentId }), payload)
  },
  resendInstallmentNotification(paymentId) {
    return http.post(endpoints.get('resendInstallmentNotification', { paymentId }))
  },
  switchChildEdition(childEditionId, paymentId) {
    return http.post(endpoints.get('switchChildEdition', { paymentId, childEditionId }))
  }
}
